import Service from '@ember/service';

import { PublicClientApplication } from '@azure/msal-browser';

import config from 'umg-ember-backend/config/environment';

export default class MsalService extends Service {
  client;

  // Derive the API scope from the environment's client ID so the access token's
  // audience always matches the backend's OIDC_CONFIG_AUDIENCE for that env.
  get scopes() {
    return [
      `api://${config.AUTH.entraClientId}/Login`,
      'openid',
      'profile',
      'email',
    ];
  }

  async setup() {
    const client = new PublicClientApplication({
      auth: {
        clientId: config.AUTH.entraClientId,
        authority:
          'https://login.microsoftonline.com/bbcb6b2f-8c7c-4e24-86e4-6c36fed00b78',
        redirectUri: window.location.origin,
      },
      cache: {
        cacheLocation: 'localStorage',
      },
    });

    await client.initialize();
    this.client = client;
  }

  get account() {
    return this.client?.getAllAccounts()[0] ?? null;
  }

  async handleRedirect() {
    return await this.client.handleRedirectPromise();
  }

  getAccessToken() {
    if (!this.account) throw new Error('No user session found');
    return this.client.acquireTokenSilent({
      scopes: this.scopes,
      account: this.account,
    });
  }

  loginRedirect() {
    return this.client.loginRedirect({ scopes: this.scopes });
  }

  logout() {
    if (this.account) {
      return this.client.logoutRedirect({
        account: this.account,
      });
    }
  }
}
